module["exports"] = [
  "com",
  "ru",
  "info",
  "рф",
  "net",
  "org"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/internet/domain_suffix.js
// module id = 1530
// module chunks = 0